import { LogoMark } from "./Logo";

const t1 = (n) => Number(n || 0).toLocaleString("id-ID", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
const TH = ({ children, className = "" }) => <th className={`bg-[#1f4e79] text-[9px] font-bold text-white print:bg-[#1f4e79] ${className}`} style={{ WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }}>{children}</th>;
const TD = ({ children, className = "", ...rest }) => <td className={`text-[10px] ${className}`} {...rest}>{children}</td>;

/** Laporan Monitoring (Proyek / Vendor / Area) — A4 landscape, header mengikuti konfigurasi grup */
export function MonitoringPrintView({ g, rows, total, user, filter }) {
  const done = (s) => s.sisa <= 0.05;
  return (
    <div className="print-sheet landscape" data-testid="mon-print-sheet">
      <div className="grid grid-cols-3 items-start gap-3 border-b-2 border-black pb-2">
        <div className="flex items-center gap-2">
          <LogoMark size={42} />
          <div className="leading-tight"><div className="font-display text-[12px] font-bold">PT HONGLU BAJA INDONESIA</div><div className="cn text-[9px]">宏睿钢印印尼有限公司</div></div>
        </div>
        <div className="text-center leading-tight">
          <div className="font-display text-xl font-black tracking-wide">{g.title[0]}</div>
          <div className="cn text-[12px] font-bold">{g.title[1]}</div>
          <div className="text-[9px] text-gray-600">Total SPK · Sudah selesai (realisasi laporan STB) · Belum selesai — satuan ton</div>
        </div>
        <div className="space-y-0.5 text-right text-[9px]">
          <div><b>Tanggal cetak / <span className="cn">打印日期</span>:</b> {new Date().toLocaleDateString("id-ID", { day: "2-digit", month: "long", year: "numeric" })}</div>
          <div><b>Dicetak oleh / <span className="cn">打印人</span>:</b> {user?.name || "Admin"}</div>
          {filter && <div><b>Filter:</b> {filter}</div>}
          <div><b>Jumlah baris:</b> {rows.length}</div>
        </div>
      </div>

      <table className="mt-2">
        <thead>
          <tr>
            <TH>{g.heads[0][0]}<br /><span className="cn font-normal">{g.heads[0][1]}</span></TH>
            {g.heads[1] && <TH>{g.heads[1][0]}<br /><span className="cn font-normal">{g.heads[1][1]}</span></TH>}
            <TH className="w-20 text-right">Total SPK<br /><span className="cn font-normal">工单总吨位</span></TH>
            <TH className="w-24 text-right">Sudah Selesai<br /><span className="cn font-normal">已完成吨位</span></TH>
            <TH className="w-20 text-right">Belum Selesai<br /><span className="cn font-normal">未完成吨位</span></TH>
            <TH>{g.subLabel[0]}<br /><span className="cn font-normal">{g.subLabel[1]}</span></TH>
            <TH className="w-20 text-right">SPK<br /><span className="cn font-normal">工单</span></TH>
            <TH className="w-24 text-right">Progress<br /><span className="cn font-normal">进度</span></TH>
            <TH className="w-20 text-right">Sisa<br /><span className="cn font-normal">剩余</span></TH>
            <TH className="w-12 text-right">%</TH>
            {!g.noStatus && <TH className="w-16">Status<br /><span className="cn font-normal">状态</span></TH>}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => r.subs.map((s, i) => (
            <tr key={`${r.id}-${s.id}`} className={i === 0 ? "border-t-2 border-black" : ""}>
              {i === 0 && (
                <>
                  <TD rowSpan={r.subs.length} className="align-top font-bold">{r.head.h1}{r.head.h1zh && <span className="cn ml-1 font-normal">{r.head.h1zh}</span>}{r.head.h1sub && <div className="font-mono text-[9px] font-normal text-gray-600">{r.head.h1sub}</div>}<div className="font-mono text-[8px] font-normal text-gray-500">{r.spkCount} SPK</div></TD>
                  {g.heads[1] && <TD rowSpan={r.subs.length} className="align-top">{r.head.h2}{r.head.h2sub && <div className="font-mono text-[9px] text-gray-600">{r.head.h2sub}</div>}{r.extra && <div className="text-[9px] text-gray-600">{r.extra}</div>}</TD>}
                  <TD rowSpan={r.subs.length} className="text-right align-top font-mono font-bold">{t1(r.spk)}</TD>
                  <TD rowSpan={r.subs.length} className="text-right align-top font-mono font-bold">{t1(r.progress)}</TD>
                  <TD rowSpan={r.subs.length} className={`text-right align-top font-mono font-bold ${r.sisa > 0.05 ? "text-red-700" : ""}`}>{t1(r.sisa)}</TD>
                </>
              )}
              <TD>{s.label}{s.zh && <span className="cn ml-1 text-gray-600">{s.zh}</span>}{s.sub && <span className="ml-1 font-mono text-[9px] text-gray-500">{s.sub}</span>}{g.subExtra && <div className="text-[9px] text-gray-600">{g.subExtra(s)}</div>}</TD>
              <TD className="text-right font-mono">{t1(s.spk)}</TD>
              <TD className="text-right font-mono">{t1(s.progress)}</TD>
              <TD className={`text-right font-mono italic ${s.sisa > 0.05 ? "text-red-700" : ""}`}>{s.sisa > 0 ? `-${t1(s.sisa)}` : t1(0)}</TD>
              <TD className="text-right font-mono">{s.pct}%</TD>
              {!g.noStatus && <TD className={`text-center text-[9px] font-bold ${done(s) ? "text-green-700" : "text-red-700"}`}>{done(s) ? <>Selesai / <span className="cn">完成</span></> : <>Belum / <span className="cn">未完成</span></>}</TD>}
            </tr>
          )))}
        </tbody>
        <tfoot>
          <tr className="bg-gray-100 font-bold">
            <TD colSpan={g.heads.length} className="text-right">TOTAL / <span className="cn">合计</span></TD>
            <TD className="text-right font-mono">{t1(total.spk)}</TD>
            <TD className="text-right font-mono">{t1(total.progress)}</TD>
            <TD className={`text-right font-mono ${total.sisa > 0.05 ? "text-red-700" : ""}`}>{t1(total.sisa)}</TD>
            <TD colSpan={4} className="text-right text-[9px] font-normal text-gray-600">Progress = realisasi laporan STB · satuan ton</TD>
            <TD className="text-right font-mono">{total.pct}%</TD>
            {!g.noStatus && <TD />}
          </tr>
        </tfoot>
      </table>

      <div className="mt-5 grid grid-cols-3 gap-6 text-[9px]">
        {["Dibuat / 制表", "Diperiksa / 审核", "Disetujui / 批准"].map((t) => (
          <div key={t} className="sig-block text-center"><div className="font-bold">{t}</div><div className="h-10" /><div className="border-t border-black pt-0.5 text-left pl-2">Nama / <span className="cn">姓名</span>: ________</div></div>
        ))}
      </div>
      <div className="mt-2 flex justify-between text-[8px] text-gray-500"><span>HONGLU FABRIKASI SISTEM · {g.page[0]}</span><span>{new Date().toLocaleString("id-ID")}</span></div>
    </div>
  );
}
